import { Id } from "./id";
import { OccupancyPeriod } from "./occupancyPeriod";
import { ResourceTypes } from "./resourceTypes";

type ResourceOccupancy = {
  uuid: Id;
  name: string;
  profession: string;
  type: ResourceTypes;
  avatarUrl: string;
  periods: OccupancyPeriod[];
};

const resourceOccupancy: ResourceOccupancy = {
  uuid: "",
  name: "",
  profession: "",
  type: ResourceTypes.HUMAN,
  avatarUrl: "",
  periods: [],
};

export type { ResourceOccupancy };

export { resourceOccupancy };
